import React from 'react';
import ProductHubDashboardV2 from '../ProductHubDashboard/ProductHubDashboardV2';

const PayPhoneHubView = () => {
  return <ProductHubDashboardV2 productCode="cpass" productLabel="CallPass" />;
};

export default PayPhoneHubView;
